/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Principles_NoteInputs */

const en_about_principles_note = /** @type {(inputs: About_Principles_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In the conversations. And in the software.`)
};

const lv_about_principles_note = /** @type {(inputs: About_Principles_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sarunās. Un programmatūrā.`)
};

/**
* | output |
* | --- |
* | "In the conversations. And in the software." |
*
* @param {About_Principles_NoteInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const about_principles_note = /** @type {((inputs?: About_Principles_NoteInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Principles_NoteInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_about_principles_note(inputs)
	return en_about_principles_note(inputs)
});